import React from 'react';
import './Page.css';

const Disclaimer = () => {
  return (
    <div className="page-container">
      <h1>Disclaimer</h1>
      <div className="page-content">
        <section>
          <h2>General Information</h2>
          <p>The information provided on Gold Price Tracker is for general informational purposes only. All information on the site is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.</p>
        </section>

        <section>
          <h2>Financial Advice</h2>
          <p>Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site is solely at your own risk.</p>
        </section>

        <section>
          <h2>External Links</h2>
          <p>The site may contain links to external websites that are not provided or maintained by or in any way affiliated with Gold Price Tracker. Please note that we do not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.</p>
        </section>

        <section>
          <h2>Errors and Omissions</h2>
          <p>While we have made every attempt to ensure that the information contained in this site has been obtained from reliable sources, Gold Price Tracker is not responsible for any errors or omissions or for the results obtained from the use of this information.</p>
        </section>

        <section>
          <h2>Fair Use</h2>
          <p>This site may contain copyrighted material the use of which has not always been specifically authorized by the copyright owner. We are making such material available in our efforts to advance understanding of environmental, political, human rights, economic, democracy, scientific, and social justice issues, etc.</p>
        </section>

        <section>
          <h2>Testimonials</h2>
          <p>At various places on this website, you may find testimonials from clients and customers of the products and services offered on this website or by this website. The testimonials are actual statements made by clients and/or customers and have been truthfully conveyed on this website.</p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have any questions about this Disclaimer, please contact us at:</p>
          <p>Email: legal@goldpricetracker.com</p>
        </section>
      </div>
    </div>
  );
};

export default Disclaimer; 